export const LPFee = 0.0017
